import { Outlet, createFileRoute } from "@tanstack/react-router"

import { AccountLayout } from "@/components/account/layout/AccountLayout"

export const Route = createFileRoute("/(public)/_account")({
  component: () => (
    <AccountLayout>
      <Outlet />
    </AccountLayout>
  ),
})
